import Vue from 'vue'
import Router from 'vue-router'
import getFormatById from '@/assets/formats/get-format-by-id'
/* トップ以外は非同期読み込み */
import formatList from '@/views/FormatList'
import formatKeirekishoList from '@/views/FormatKeirekishoList'
import top from '@/views/Top'
import topdl from '@/views/TopDl'
Vue.use(Router)

// const SITE_TITLE = process.env.VUE_APP_SITE_TITLE
const SITE_TITLE = '무료 이력서 작성 서비스 yagish (야기슈)'
const NOT_FOUND_PATH = '/404'

const previewProps = function (route) {
  return {
    preview: true,
    formatId: route.params.formatId,
    cardId: route.params.cardId
  }
}

const getCardTitle = function (cards, cardId) {
  const result = cards.find(function (card) {
    return card.id === cardId
  })
  if (result) return result.title
}

const getFormatMeta = function (formatId, cardId) {
  const result = getFormatById(formatId)
  if (result) {
    return {
      title: result.title,
      description: result.description,
      cardTitle: getCardTitle(result.cards, cardId)
    }
  }
}

/*
** SEO用 title、meta descriptionを作成
*/
const setFormatMeta = function (to) {
  let formatMeta = getFormatMeta(to.params.formatId, to.params.cardId)
  if (!formatMeta) {
    console.error('format meta not set.')
    return
  }
  if (formatMeta.cardTitle) {
    document.title = `${formatMeta.cardTitle} - ${formatMeta.title} - ${to.meta.title}`
    metaDescriptionElement.content = `${formatMeta.title}의${formatMeta.cardTitle}의 페이지입니다.${formatMeta.description}`
  } else {
    document.title = `${formatMeta.title}  - ${to.meta.title}`
    metaDescriptionElement.content = formatMeta.description
  }
  console.log(to)
  if (to.meta.linkformat == 1) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}`
  } else if (to.meta.linkformat == 2) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}`
  } else if (to.meta.linkformat == 3) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit`
  } else if (to.meta.linkformat == 4) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit/${to.params.cardId}`
  } else if (to.meta.linkformat == 5) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit/${to.params.cardId}/preview`
  } else if (to.meta.linkformat == 6) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/${to.path}`
  }
}

const formatExistsOr404 = function (to, from, next) {
  if (!to.params.formatId) {
    next({ name: 'notFound' })
    return
  }
  const id = to.params.formatId
  const formatResult = getFormatById(id)
  if (!formatResult) {
    next({ name: 'notFound' })
    return
  }
  if (!to.params.cardId) {
    next()
    return
  }
  const cardId = to.params.cardId
  const cardResult = formatResult.cards.find(function (card) { return card.id === cardId })
  if (!cardResult) {
    next({ name: 'notFound' })
    return
  }
  next()
}

const routes = [
  {
    path: '/kr/resume/dl',
    component: topdl,
    name: 'topdl',
    meta: {
      title: SITE_TITLE,
      linkformat: 1
    }
  },
  {
    path: '/kr',
    component: top,
    name: 'top',
    meta: {
      title: SITE_TITLE,
      linkformat: 1
    }
  },
  {
    path: '/kr/resume/',
    component: top,
    name: 'top',
    meta: {
      title: SITE_TITLE,
      linkformat: 1
    }
  },
  {
    path: '/kr/resume/keirekisho',
    component: formatKeirekishoList,
    name: 'keirekisho_top',
    meta: {
      title: SITE_TITLE,
      linkformat: 1
    }
  },
  {
    path: '/kr/resume/top',
    component: top,
    name: 'new_top',
    meta: {
      title: SITE_TITLE,
      linkformat: 1
    }
  },
  {
    path: '/kr/resume/format/:formatId',
    component: () => import('@/views/FormatDetail'),
    props: true,
    beforeEnter: formatExistsOr404,
    name: 'formatDetail',
    meta: {
      title: `템플릿 - ${SITE_TITLE}`,
      linkformat: 2
    }
  },
  {
    path: '/kr/resume/format/:formatId/edit',
    component: () => import('@/views/FormatEdit'),
    props: true,
    name: 'formatEdit',
    beforeEnter: formatExistsOr404,
    meta: {
      title: `수정 - ${SITE_TITLE}`,
      linkformat: 3
    }
  },
  {
    path: '/kr/resume/format/:formatId/edit/:cardId',
    component: () => import('@/views/FormatEdit'),
    props: true,
    name: 'formatEditCard',
    beforeEnter: formatExistsOr404,
    meta: {
      title: `수정 - ${SITE_TITLE}`,
      linkformat: 4
    }
  },
  {
    path: '/kr/resume/format/:formatId/edit/:cardId/preview',
    component: () => import('@/views/FormatEdit'),
    props: previewProps,
    name: 'formatPreview',
    beforeEnter: formatExistsOr404,
    meta: {
      title: `미리보기 - ${SITE_TITLE}`,
      linkformat: 5
    }
  },
  {
    path: '/kr/resume/recomm/:secureId/:secureKey',
    component: () => import('@/views/pages/Introduction'),
    props: true,
    name: 'IntroductionPage',
    meta: {
      title: `소개 및 추천 입력 페이지 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 소개 및 추천 입력 페이지입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/recomm/:secureId',
    component: () => import('@/views/pages/Introduction'),
    props: true,
    name: 'IntroductionPage',
    meta: {
      title: `소개 및 추천 입력 페이지 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 소개 및 추천 입력 페이지입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/recomm_preview/:accessId',
    component: () => import('@/views/IntroductionPreview'),
    props: true,
    name: 'IntroductionPreviewPage',
    meta: {
      title: `소개 및 추천 미리보기 - ${SITE_TITLE}`,
      linkformat: 5
    }
  },
  {
    path: '/kr/resume/athlete/:formatId/:univId',
    component: () => import('@/views/FormatDetail'),
    props: true,
    beforeEnter: formatExistsOr404,
    name: 'formatDetail',
    meta: {
      title: `템플릿 - ${SITE_TITLE}`,
      linkformat: 2
    }
  },
  {
    path: '/kr/resume/help',
    component: () => import('@/views/pages/Help'),
    name: 'helpPage',
    meta: {
      title: `헬프 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 헬프입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/download',
    component: () => import('@/views/pages/Download'),
    name: 'downloadPage',
    meta: {
      title: `다운로드 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 다운로드 페이지입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/jobdetail_rt',
    component: () => import('@/views/JobdetailRt'),
    name: 'JobdetailRtPage',
    meta: {
      title: `구인상세리다이렉트 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}구인 상세 리다이렉트 페이지입니다`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/bokumetsu',
    component: () => import('@/views/pages/Bokumetsu'),
    name: 'bokumetsuPage',
    meta: {
      title: `수기 이력서 박멸 캠페인 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 수기 이력서 박멸 캠페인 페이지 입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/cvtest',
    component: () => import('@/views/pages/CvTest'),
    name: 'cvtest',
    meta: {
      title: `이용약관 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 이용약관입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/terms',
    component: () => import('@/views/pages/Terms'),
    name: 'termsPage',
    meta: {
      title: `이용약관 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 이용약관입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/tempterms',
    component: () => import('@/views/pages/Terms_copy'),
    name: 'termsPage',
    meta: {
      title: `이용약관 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 이용약관입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/quickmailterms',
    component: () => import('@/views/pages/QuickmailTerms'),
    name: 'termsPage',
    meta: {
      title: `ヤギの宅配便の利用規約 - ${SITE_TITLE}`,
      description: `ヤギの宅配便の利用規約です`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/quickemailterms',
    component: () => import('@/views/pages/QuickEmailTerms'),
    name: 'termsPage',
    meta: {
      title: `ヤギのメール便の利用規約 - ${SITE_TITLE}`,
      description: `ヤギのメール便の利用規約です`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/qmail_preview/:confirmCode',
    component: () => import('@/views/QuickEmailPreview'),
    props: true,
    name: 'QuickEmailPreview',
    meta: {
      title: `미리보기 - ${SITE_TITLE}`,
      linkformat: 5
    }
  },
  {
    path: '/kr/resume/yagiofferterms',
    component: () => import('@/views/pages/YagiofferTerms'),
    name: 'termsPage',
    meta: {
      title: `ヤギオファーの利用規約 - ${SITE_TITLE}`,
      description: `ヤギオファーの利用規約です`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/fontservicehelp',
    component: () => import('@/views/pages/FontHelp'),
    name: 'fontServiceHelpPage',
    meta: {
      title: `有料フォントの利用方法 - ${SITE_TITLE}`,
      description: `有料フォントの利用方法説明ページです`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/quickmailhelp',
    component: () => import('@/views/pages/QuickmailHelp'),
    name: 'termsPage',
    meta: {
      title: `ヤギの宅配便の利用方法 - ${SITE_TITLE}`,
      description: `ヤギの宅配便の利用方法説明ページです`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/quickemailhelp',
    component: () => import('@/views/pages/QuickEmailHelp'),
    name: 'termsPage',
    meta: {
      title: `ヤギのメール便の利用方法 - ${SITE_TITLE}`,
      description: `ヤギのメール便の利用方法説明ページです`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/yagiofferhelp',
    component: () => import('@/views/pages/YagiofferHelp'),
    name: 'yagiofferHelpPage',
    meta: {
      title: `ヤギオファーの利用方法 - ${SITE_TITLE}`,
      description: `ヤギオファーの利用方法説明ページです`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/privacy',
    component: () => import('@/views/pages/Privacy'),
    name: 'policyPage',
    meta: {
      title: `개인정보보호방침 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 개인정보보호방침 페이지입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/secure_privacy',
    component: () => import('@/views/pages/SecurePrivacy'),
    name: 'securePage',
    meta: {
      title: `개인정보보호방침 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 개인정보보호정책 페이지입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/company',
    name: 'companyPage',
    // beforeEnter() {
    //   window.location = "https://www.yagish.jp"
    // }
    component: () => import('@/views/pages/Company'),
    name: 'companyPage',
    meta: {
      title: `운영회사 소개 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 회사소개 페이지 입니다`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/checklist_jobchange/:formatId/:cardId',
    component: () => import('@/views/pages/Jobagree'),
    name: 'JobagreePage',
    meta: {
      title: `「転職活動チェックリスト」で準備、対策、進め方を把握しよう！ - ${SITE_TITLE}`,
      description: `転職活動はいざ始まると忙しくなるので、予めやることをチェックリストで把握しておくことが大切です。
      Yagish(ヤギッシュ)は「自己分析」「履歴書・職歴書の添削」「退職手続き」「自分に合った会社の選定」など効率の良い転職活動をサポートします。`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/quickmail/:cardId',
    component: () => import('@/views/QuickMailService'),
    props: true,
    name: 'quickmailCard',
    meta: {
      title: `ヤギの宅配便 - ${SITE_TITLE}`,
      linkformat: 4
    }
  },
  {
    path: '/kr/resume/quickemail/:cardId',
    component: () => import('@/views/QuickEMailService'),
    props: true,
    name: 'quickemailCard',
    meta: {
      title: `ヤギのメール便 - ${SITE_TITLE}`,
      linkformat: 4
    }
  },
  {
    path: '/kr/resume/info',
    component: () => import('@/views/pages/ServiceInfo'),
    name: 'serviceInfoPage',
    meta: {
      title: `서비스에 대하여 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 서비스 설명페이지 입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/mailmaga/:clientId',
    component: () => import('@/views/pages/Mailmaga'),
    name: 'mailMagaPage',
    props: true,
    meta: {
      title: `추천정보 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}로 부터 당신에게 추천정보를 소개하는 페이지 입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/oldlogin',
    component: () => import('@/views/pages/Login'),
    name: 'loginPage',
    meta: {
      title: `로그인 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 로그인페이지입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/idpwlogin',
    component: () => import('@/views/pages/IdPwLogin'),
    name: 'loginPage',
    meta: {
      title: `로그인 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 로그인페이지입니다`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/login',
    component: () => import('@/views/pages/NewLogin'),
    name: 'loginPage',
    meta: {
      title: `로그인 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 로그인페이지입니다`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/mregister',
    component: () => import('@/views/pages/Register'),
    name: 'registerPage',
    meta: {
      title: `회원등록 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 회원등록 페이지입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/oldmypage',
    component: () => import('@/views/pages/OldMyPage'),
    name: 'myPage',
    meta: {
      title: `마이페이지 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 마이페이지입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/repasswd',
    component: () => import('@/views/pages/RePasswd'),
    name: 'rePasswdPage',
    meta: {
      title: `패스워드 재발급 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 패스워드 재발급 페이지입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/mypage',
    component: () => import('@/views/pages/mypage/MyPage'),
    name: 'myPage',
    meta: {
      title: `마이페이지 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 마이페이지입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/mypage/basicinfo',
    component: () => import('@/views/pages/mypage/BasicinfoMyPage'),
    name: 'KimanMyPage',
    meta: {
      title: `마이페이지:기본정보변경 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의마이페이지:기본정보변경 페이지입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/mypage/yagioffer',
    component: () => import('@/views/pages/mypage/YagiofferMyPage'),
    name: 'KimanMyPage',
    meta: {
      title: `マイページ:ヤギオファー - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のマイページ:ヤギオファーです`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/mypage/quickmail',
    component: () => import('@/views/pages/mypage/QuickmailMyPage'),
    name: 'KimanMyPage',
    meta: {
      title: `マイページ:ヤギの宅配便 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のマイページ:ヤギの宅配便です`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/mypage/quickemail',
    component: () => import('@/views/pages/mypage/QuickemailMyPage'),
    name: 'KimanMyPage',
    meta: {
      title: `マイページ:ヤギのメール便 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のマイページ:ヤギのメール便です`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/mypage/introduction',
    component: () => import('@/views/pages/mypage/IntroductionMyPage'),
    name: 'KimanMyPage',
    meta: {
      title: `マイページ:推薦・紹介 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のマイページ:推薦・紹介です`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/infosave',
    component: () => import('@/views/pages/ServiceInfoSave'),
    name: 'serviceInfoSavePage',
    meta: {
      title: `입력 정보보관 대하여 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}의 입력 정보보관 페이지입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/article',
    component: () => import('@/views/pages/article/Article'),
    name: 'article',
    meta: {
      title: `유용한 정보 - ${SITE_TITLE}`,
      description: `이 페이지는 기사 목록입니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/article/guide01',
    component: () => import('@/views/pages/article/Article01'),
    name: 'guide01',
    meta: {
      title: `이력서 작성 완벽 가이드｜양식, 예문, 꿀팁까지 총정리 - ${SITE_TITLE}`,
      description: `이력서, 어떻게 써야 할지 막막하다면? 인적사항부터 학력, 경력, 자격증까지 항목별 작성법과 예시를 통해 이력서를 완성해보세요.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/article/guide02',
    component: () => import('@/views/pages/article/Article02'),
    name: 'guide02',
    meta: {
      title: `이력서 학력 기재법 완벽 정리｜작성 순서, 주의사항, 예시까지 - ${SITE_TITLE}`,
      description: `이력서 학력 작성, 헷갈리셨나요? 최신 작성 순서, 졸업·중퇴 표기법, 상황별 예시까지! 실수 없이 완성하는 학력란 작성법을 이 글에서 자세히 알려드립니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/article/guide03',
    component: () => import('@/views/pages/article/Article03'),
    name: 'guide03',
    meta: {
      title: `이력서 경력사항 작성법 완전 정리｜경력 기술서 예시 & 직무별 팁 - ${SITE_TITLE}`,
      description: `이력서 경력사항, 어떻게 써야 할까요? STAR 기법, 수치 중심 표현, 직무별 예시까지! 인사 담당자에게 신뢰를 주는 경력 작성법을 이 글에서 완벽하게 정리해드립니다.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/article/guide04',
    component: () => import('@/views/pages/article/Article04'),
    name: 'guide04',
    meta: {
      title: `이력서 지원동기 예시 & 꿀팁 ! 취업 성공 첫걸음 - ${SITE_TITLE}`,
      description: `지원동기 작성법 : 합격하는 이력서의 비밀.`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/article/guide05',
    component: () => import('@/views/pages/article/Article05'),
    name: 'guide05',
    meta: {
      title: `자기 PR 이렇게 쓰면 합격률 UP! 실전 팁 & 예시 - ${SITE_TITLE}`,
      description: `채용 담당자가 인정하는 합격 이력서 작성 노하우`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/article/guide06',
    component: () => import('@/views/pages/article/Article06'),
    name: 'guide06',
    meta: {
      title: `이력서 합격 공식! 바로 적용할 수 있는 실전 팁 - ${SITE_TITLE}`,
      description: `채용 담당자가 인정하는 합격 이력서 작성 노하우`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/postcard',
    component: () => import('@/views/YagiPostCard'),
    name: 'postCard',
    meta: {
      title: `ヤギにハガキを渡す - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の運営元宛てのハガキをヤギに頼めます`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/gacha',
    component: () => import('@/views/YagiGacha'),
    name: 'gacha',
    meta: {
      title: `ガチャ - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - ガチャ`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/hiroba',
    component: () => import('@/views/YagiHiroba'),
    name: 'hiroba',
    meta: {
      title: `広場 - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - 広場`,
      linkformat: 6
    }
  },
  {
    path: '/kr/resume/account/delete',
    component: () => import('@/views/AccountDelete'),
    name: 'accountDelete',
    meta: {
      title: `데이터・계정삭제 - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - 広場`,
      linkformat: 6
    }
  },

  {
    path: NOT_FOUND_PATH,
    component: () => import('@/views/NotFound'),
    alias: ['/404.html'],
    name: 'notFound',
    meta: {
      title: `페이지를 찾을 수 없습니다. - ${SITE_TITLE}`,
      linkformat: 1
    }
  },
  {
    path: '/kr*',
    redirect: { name: 'notFound' }
  }
]
if (process.env.VUE_APP_MODE === 'development') {
  routes.push({
    path: '/kr/resume/admin',
    component: () => import('@/views/AdminIndex'),
    name: 'adminIndex',
    meta: {
      title: `管理用 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}で入力したデータのバックアップ作成やプレビュー、復元をすることができます。`
    }
  })
}
const router = new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior: function (to, from, savedPosition) {
    if (savedPosition) return savedPosition
    // カード間の移動時は
    // 最上部へのスクロールを無視する
    if (to.name === 'formatEditCard' && from.name === 'formatEditCard') {
      return
    }
    return { x: 0, y: 0 }
  }
})

const metaDescriptionElement = document.getElementById('head-meta-description')
const headLinkCanonical = document.getElementById('head-link-canonical')
const defaultDescription = metaDescriptionElement.content
router.afterEach((to, from) => {
  if (to.params.formatId) {
    setFormatMeta(to)
  } else if (to.meta && to.meta.title) {
    document.title = to.meta.title
    if (to.meta.description) {
      metaDescriptionElement.content = to.meta.description
    } else {
      metaDescriptionElement.content = defaultDescription
    }
    if (to.meta.linkformat == 1) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}`
    } else if (to.meta.linkformat == 2) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}`
    } else if (to.meta.linkformat == 3) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit`
    } else if (to.meta.linkformat == 4) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit/${to.params.cardId}`
    } else if (to.meta.linkformat == 5) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit/${to.params.cardId}/preview`
    } else if (to.meta.linkformat == 6) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}${to.path}`
    }
  }
})
export default router
